import { isRestaurantMealPeriodActive } from './menuUnification.utils';
import { EXPRESS_MODE_MEAL_PERIOD_PREFIX } from './menuUnification.constants';
import { IRestaurantMealPeriod } from '../types/brandMenu';

/**
 * Detect whether the current restaurant has any "express mode" meal period
 * active right now. Express-mode meal periods are named with a prefix of
 * "express mode" (e.g. "express mode evening", "express mode lunch") and
 * may not be assigned to any item or constraint — so we scan the meal
 * periods map directly. The map is already filtered to the meal periods
 * that apply to the current restaurant (via restaurant_group membership).
 */
export const getExpressModePeriods = (
  restaurantMealPeriodsByName?: Record<string, IRestaurantMealPeriod>
): IRestaurantMealPeriod[] =>
  Object.values(restaurantMealPeriodsByName ?? {}).filter((mp) =>
    mp?.name?.toLowerCase().startsWith(EXPRESS_MODE_MEAL_PERIOD_PREFIX)
  );

export const hasExpressModePeriods = (
  restaurantMealPeriodsByName?: Record<string, IRestaurantMealPeriod>
): boolean => getExpressModePeriods(restaurantMealPeriodsByName).length > 0;

export const isExpressModeActive = (
  restaurantMealPeriodsByName?: Record<string, IRestaurantMealPeriod>,
  timezone?: string
): boolean => {
  if (!restaurantMealPeriodsByName || !timezone) {
    return false;
  }

  const expressModePeriods = getExpressModePeriods(restaurantMealPeriodsByName);

  if (expressModePeriods.length === 0) {
    return false;
  }

  for (const mp of expressModePeriods) {
    if (isRestaurantMealPeriodActive(mp, timezone)) {
      return true;
    }
  }

  return false;
};
